import { Link } from "react-router-dom";
import type { Topic } from "@/types/content";
import { formatHeat, rankTone } from "@/utils/format";

interface RankRowProps {
  topic: Topic;
  position: number;
  showHeat?: boolean;
}

export default function RankRow({ topic, position, showHeat = true }: RankRowProps) {
  return (
    <Link
      to={`/topic/${topic.id}`}
      className="group flex items-center gap-3 rounded-md px-2 py-3 transition-colors hover:bg-background-100"
    >
      <span
        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${rankTone(position)}`}
      >
        {position}
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm text-foreground-900 transition-colors group-hover:text-primary-600">
          {topic.title}
        </span>
        <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <span className="text-secondary-600">{topic.category}</span>
          <span className="text-background-400">·</span>
          <span>{topic.publishTime}</span>
        </span>
      </span>
      {showHeat && (
        <span className="flex shrink-0 items-center gap-1 text-xs font-medium text-primary-600">
          <i className="ri-fire-fill"></i>
          {formatHeat(topic.heat)}
        </span>
      )}
    </Link>
  );
}